import React from 'react';
import { BackofficeNav } from '../BackofficeNav';
import { BackofficeBreadcrumb } from './BackofficeBreadcrumb';

/**
 * Height of the sticky nav bar: its `h-11` row (44px) plus 1px bottom border. Exposed as
 * `--backoffice-nav-h` so a page's own sticky headers and full-height layouts can offset by it
 * instead of guessing (`top-[var(--backoffice-nav-h)]`, `calc(100dvh - var(--backoffice-nav-h))`).
 */
export const BACKOFFICE_NAV_HEIGHT = '2.8125rem';

/**
 * The frame around every /backoffice page (mounted by LayoutDefault's backoffice branch, inside MinimalChrome): sticky nav,
 * breadcrumb on sub-pages, and one page background. A page renders only its own content and lets
 * this fill the space under the nav: make its root `flex-1` (add `flex flex-col` if it lays out
 * as a column), and don't add a `min-h-screen` or a background of its own.
 */
export function BackofficeShell({ children }: { children: React.ReactNode }) {
  return (
    <div
      className="flex min-h-screen flex-col bg-jc-page"
      style={{ '--backoffice-nav-h': BACKOFFICE_NAV_HEIGHT } as React.CSSProperties}
    >
      <div className="sticky top-0 z-40">
        <BackofficeNav />
      </div>
      <BackofficeBreadcrumb />
      {children}
    </div>
  );
}
